import * as React from 'react';

function SvgDictOutlined(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" className="DictOutlined_svg__icon" viewBox="0 0 1024 1024" {...props}>
      <path d="M256.003 672v-64c0-35.348 28.651-64.005 64-64.005h383.995c35.343 0 64 28.657 64 64.005v64c0 35.348-28.657 64-64 64H320.003c-35.349 0-64-28.652-64-64zm431.995 0a16 16 0 0016.005-16v-32a16 16 0 00-16.005-16H336.003a16 16 0 00-16 16v32a16 16 0 0016 16h351.995zm208 351.995h-768c-35.349 0-64-28.662-64-64.005V159.995C63.998 71.629 135.632 0 223.998 0h576a31.99 31.99 0 0132 31.99 32.01 32.01 0 01-32 32.01h-576c-53.018 0-96 42.967-96 95.995 0 53.012 42.982 95.995 96 95.995h576a32 32 0 010 64.005h-576c-36.188 0-69.192-12.472-96-32.722v608.722c0 35.343 28.651 64.005 64 64.005h640c35.348 0 64-28.657 64-64.005v-640c0-35.349-28.652-64-64-64h-608a32.005 32.005 0 010-64.005h672c35.348 0 64 28.656 64 64v768c0 35.343-28.652 64.005-64 64.005z" />
    </svg>
  );
}

export default SvgDictOutlined;
